(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('WikiSpaceController', WikiSpaceController);

    WikiSpaceController.$inject = ['$uibModal', 'WikiSpace', 'Wiki', 'AlertService'];

    function WikiSpaceController($uibModal, WikiSpace, Wiki, AlertService) {
        var vm = this;
        vm.spaces = [];
        vm.edit = edit;
        vm.remove = remove;
        vm.openCreate = openCreate;

        load();

        function load() {
            WikiSpace.query({}, function (data) {
                vm.spaces = data;
                vm.spaces.forEach(function (space) {
                    Wiki.query({spaceId: space.id}, function (pages) {
                        space.pageCount = pages.length;
                    });
                });
            });
        }

        function edit(space) {
            $uibModal.open({
                templateUrl: 'app/entities/wiki/wiki-space-dialog.html',
                controller: 'WikiSpaceDialogController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function () {
                        return angular.copy(space);
                    }
                }
            }).result.then(function () {
                load();
            }, angular.noop);
        }

        function openCreate() {
            $uibModal.open({
                templateUrl: 'app/entities/wiki/wiki-space-dialog.html',
                controller: 'WikiSpaceDialogController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function () {
                        return {id: null, nome: null, descricao: null, ordem: 100};
                    }
                }
            }).result.then(function () {
                load();
            }, angular.noop);
        }

        function remove(space) {
            WikiSpace.delete({id: space.id}, function () {
                load();
            }, function (error) {
                if (error && error.data && error.data.message) {
                    AlertService.error(error.data.message);
                }
            });
        }
    }
})();
